import { Component } from '@angular/core';

@Component({
  selector: 'app-style-buttons',
  templateUrl: './style-buttons.component.html',
  standalone: false,
})
export class StyleButtonsComponent {}
